import { ProjectionKind, useDocumentsDataTable } from 'generated/resources/datatable.graphql'

import DocumentType from 'modules/core/components/DocumentType'

import { Document } from 'modules/documents/hooks/documents/useGetDocuments'

type DocumentsDataTableProjection = Parameters<typeof useDocumentsDataTable>[0][number]

const contentTypeProjection: () => DocumentsDataTableProjection = () => ({
  identifier: 'contentType',
  title: '',
  kind: ProjectionKind.Custom,
  template: '',
  render: ({ contentType }: Document) => {
    if (!contentType) return null

    return <DocumentType mimetype={contentType} />
  },
  width: 45,
})

export default contentTypeProjection
